import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { ButtonSvgIcon, StripHtmlPipe, TooltipDirective } from '@mkp/shared/ui-library';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ui-product-tooltip',
  imports: [MatIconModule, TooltipDirective, TranslateModule, StripHtmlPipe],
  templateUrl: './product-tooltip.component.html',
  styleUrl: './product-tooltip.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class ProductTooltipComponent {
  @Input() text!: string;
  @Input() icon = ButtonSvgIcon.Information;

  iconName = 'info-icon';

  constructor() {
    const iconRegistry = inject(MatIconRegistry);
    const sanitizer = inject(DomSanitizer);

    iconRegistry.addSvgIcon(this.iconName, sanitizer.bypassSecurityTrustResourceUrl(this.icon));
  }
}
